import { Component, OnInit, Input } from '@angular/core';

import { ServicesService } from '../../../services/services/services.service';
import { GlobalCommsService } from '../../../services/global-comms/global-comms.service';

import { LoyaltyAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-loyalty-cards',
  templateUrl: './loyalty-cards.component.html',
  styleUrls: ['./loyalty-cards.component.scss']
})
export class LoyaltyCardsComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  key: string;
  extraData: Object;

  miscData: Object = {};

  loading: boolean;

  constructor(
    private servicesService: ServicesService,
    private globalCommsService: GlobalCommsService,
  ) { }

  ngOnInit() {

    this.key = 'loyalty-cards';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: LoyaltyAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'loyalty-cards',
        title: 'Loyalty Cards',
        type: 'children',
        childType: 'loyalty-card',
        plural: 'loyalty cards',
        singular: 'Loyalty card',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
